import { render, staticRenderFns } from "./FormerNamesEditor.vue?vue&type=template&id=2a3d11d5&"
import script from "./FormerNamesEditor.vue?vue&type=script&lang=js&"
export * from "./FormerNamesEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports